module.exports = __webpack_public_path__ + "static/media/state2025.24a071c6.jpg";